<script setup lang="ts">
import ClaimSummary from '../components/ClaimSummary.vue';
</script>

<template>
  <main>
    <ClaimSummary />
  </main>
</template>
